module.exports = __webpack_public_path__ + "video/300_PAB_2021_HelloFromSam.8d7bcc28.vtt";